// Service page content for Permanent Residence Skilled Regional (Subclass 191).
// Sourced from docs/research/australian-visa-pathways.md §1.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. Income threshold and evidence rules framed as
// "confirm current", not stated as exact figures; no guarantees. "Who does what"
// disclosure and disclaimer are rendered by the shared page template.

const permanentRegional191 = {
  groupSlug: "skilled-migration",
  slug: "permanent-regional-191",
  title: "Permanent Residence (Skilled Regional) visa (Subclass 191)",
  eyebrow: "Skilled Migration",
  intro:
    "The Subclass 191 is the permanent residence visa for people who hold an eligible regional provisional visa, such as the 491, and have met its conditions. It is not points-tested. Once you have lived in a designated regional area and met the income requirement for the required period, the 191 converts your provisional status to permanent residence.",

  chips: [
    { label: "Visa type", value: "Permanent residence" },
    { label: "Points-tested", value: "No" },
    { label: "Comes after", value: "A 491 (or older 494)" },
    { label: "Key test", value: "Regional living + income" },
  ],

  whoFor: [
    "Holders of a Subclass 491 (or the older 494) who have met the regional conditions.",
    "People who have lived in a designated regional area and have the tax records to prove it.",
    "Provisional visa holders ready to convert to permanent residence.",
  ],

  essentials: [
    {
      title: "An eligible regional provisional visa",
      detail:
        "You must hold, or have held, a qualifying regional visa such as the 491 or the earlier 494.",
    },
    {
      title: "Time lived in a designated regional area",
      detail:
        "You must have lived in a designated regional area for the required period while holding the provisional visa.",
    },
    {
      title: "A minimum taxable income",
      detail:
        "You must have earned at least the required minimum taxable income for the qualifying years. The exact threshold is set by legislative instrument and should be confirmed for your period.",
    },
    {
      title: "Tax returns as evidence",
      detail:
        "Notices of assessment and tax returns are the core evidence. Keeping clean records throughout the 491 makes the 191 straightforward.",
    },
    {
      title: "Health and character requirements",
      detail:
        "All applicants and included family members must meet the Department's health and character requirements.",
    },
  ],

  process: [
    {
      title: "Confirm you qualify",
      detail:
        "A registered migration agent checks your regional-residence period and income against the current 191 requirements.",
    },
    {
      title: "Assemble your evidence",
      detail:
        "We pull together your tax records, residence evidence, and provisional-visa history into a clear file.",
    },
    {
      title: "Lodge the 191 application",
      detail:
        "We prepare a thorough file. A registered migration agent lodges the application and deals with the Department.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. If granted, the 191 is permanent residence.",
    },
  ],

  faqs: [
    {
      q: "Do I need to sit the points test again for the 191?",
      a: "No. The 191 is not points-tested. It is about proving you met the regional-residence and income conditions of your provisional visa, not re-scoring you.",
    },
    {
      q: "How much income do I need to show?",
      a: "There is a minimum taxable income requirement for the qualifying years, set by legislative instrument and updated over time. A registered migration agent confirms the exact figure that applies to your period rather than quoting an out-of-date number.",
    },
    {
      q: "How long do I have to live regionally first?",
      a: "Generally you need to have lived in a designated regional area and met the income test for at least three years while holding the provisional visa. We help you organise and track the records from the day your 491 is granted.",
    },
    {
      q: "What if I am short on income for one year?",
      a: "It can affect your eligibility, so it is worth planning early. We organise your records, and a registered migration agent reviews them and tells you where you stand before you lodge.",
    },
  ],

  related: ["skilled-regional-491", "skilled-nominated-190", "skills-assessment"],

  lastVerified: "13 July 2026",
};

export default permanentRegional191;
